import { Box, Text } from '@rsos/components/capstone/base';
import { Checkbox } from '../../constants/ShareEvent.types';
import ShareEventCheckbox from '../common/ShareEventCheckbox';

interface DataSourcesAndInvitesProps {
  onChange: (field: string, newValue: Checkbox[]) => void;
  sources: Checkbox[];
}

const DataSourcesAndInvites = ({
  onChange,
  sources,
}: DataSourcesAndInvitesProps) => {
  const handleSourceChange = (checkboxId: string) => () => {
    const updatedSources = sources.map(source =>
      source.id === checkboxId
        ? { ...source, isChecked: !source.isChecked }
        : source,
    );
    onChange('dataSources', updatedSources);
  };

  return (
    <Box>
      <Text size="small" color="lightDanger" mb="16px">
        Required*
      </Text>
      <Text size="normal" fontWeight="bold" color="primaryText">
        Data Sources
        <Text inline color="lightDanger">
          *
        </Text>
      </Text>
      <Text size="normal" color="secondaryText" mb="16px">
        Select data sources to share
      </Text>
      {sources.map(checkbox => {
        return (
          <ShareEventCheckbox
            checkbox={checkbox}
            onChange={handleSourceChange(checkbox.id)}
            key={checkbox.label}
          />
        );
      })}
    </Box>
  );
};

export default DataSourcesAndInvites;
